import "../../polyfills";
import "../../base.css";

import React from "react";
import { createRoot } from "react-dom/client";

import {
  loginFailure,
  loginStart,
  loginSuccess,
} from "~/src/helpers/loginActions";

import {
  dispatch,
  getPropertiesFromQuery,
  getTranslationsLocale,
} from "../../helpers/iframeHelpers";
import SimpleTranslateProvider from "../../SimpleTranslateProvider";
import EmailLoginFormView from "./EmailLoginFormView";
import enUsTranslations from "./locales/en_US.json";
import frCaTranslations from "./locales/fr_CA.json";
import frFrTranslations from "./locales/fr_FR.json";

const { locale } = getPropertiesFromQuery();
const translationsLocale = getTranslationsLocale(locale);

const mappedPropertiesToDispatch = {
  loginFailure: (data) => dispatch(loginFailure(data)),
  loginStart: () => dispatch(loginStart()),
  loginSuccess: (data) => dispatch(loginSuccess(data)),
};

function renderPage(translations) {
  // if the translation is missing, display the key to prevent a missing translation blocking the page render
  const translate = (key) => translations[key] || key;

  const root = createRoot(document.querySelector("#container"));

  root.render(
    <SimpleTranslateProvider translate={translate}>
      <EmailLoginFormView {...mappedPropertiesToDispatch} />
    </SimpleTranslateProvider>
  );
}

let translations;
switch (translationsLocale) {
  case "en_US": {
    translations = enUsTranslations;
    break;
  }
  case "fr_CA": {
    translations = frCaTranslations;
    break;
  }
  case "fr_FR": {
    translations = frFrTranslations;
    break;
  }
  default: {
    translations = enUsTranslations;
  }
}

renderPage(translations);
